import { DEFAULT_TRACK_ROUTE } from "./constants";
import isClientSide from "./isClientSide";
/**
 * Function for sending track events from client-side code
 *
 * @param trackArguments - The event to be sent to Split
 * @param splitKey - The Split key (or Promise of Split key) to be used
 * @param options.apiPathString - The path to your application's treatment endpoint to override default.
 **/
const sendClientSideSplitTrackEvent = async (trackArguments, splitKey, { apiPathString = DEFAULT_TRACK_ROUTE, } = {}) => {
    try {
        if (!isClientSide()) {
            throw new Error("cannot use server-side, use sendServerSideSplitTrackEvent instead");
        }
        const response = await fetch(apiPathString, {
            body: JSON.stringify({
                splitKey: await splitKey,
                trackArguments,
            }),
            keepalive: true,
            method: "POST",
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(`${response.status} ${data.error || response.statusText}`);
        }
        else {
            return data.success;
        }
    }
    catch (e) {
        const trackEventType = typeof trackArguments === "string"
            ? trackArguments
            : trackArguments.eventType;
        const errorType = typeof e;
        const errorMessage = (errorType === "object" && e.message) ||
            (errorType === "string" && e) ||
            `ERROR_${errorType}_NO_MESSAGE`;
        // Load failed error means the user has navigated away from the page before the Split call has completed.
        if (errorMessage !== "Load failed") {
            console.error(new Error(`sendClientSideSplitTrackEvent error for event ${trackEventType} ${errorMessage}`));
        }
        return false;
    }
};
export default sendClientSideSplitTrackEvent;
